import { withInstall } from '@tav-ui/utils/with-install'
import Scrollbar from './src/scrollbar.vue'
const TaScrollbar = withInstall(Scrollbar)
export { TaScrollbar }
export default TaScrollbar
export * from './src/types'
